import { render, staticRenderFns } from "./Select.vue?vue&type=template&id=250e87a4&scoped=true&"
import script from "./Select.vue?vue&type=script&lang=js&"
export * from "./Select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250e87a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('250e87a4')) {
      api.createRecord('250e87a4', component.options)
    } else {
      api.reload('250e87a4', component.options)
    }
    module.hot.accept("./Select.vue?vue&type=template&id=250e87a4&scoped=true&", function () {
      api.rerender('250e87a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomField/Choice/Select.vue"
export default component.exports